import { useFeature } from '@thesisedu/feature-react'

import { BadgesReactFeature } from './BadgesReactFeature'

export function usePlaceholder() {
  const feature = useFeature(BadgesReactFeature)
  return feature.placeholder
}
